"use client";

import { useEffect, useState } from "react";

import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";
import _ from "lodash";


export default function CompanyValue() {

    const [selected, setSelected] = useState<any>({});

    useEffect(() => {
        setSelected(ourValues[0]);
    }, []);

    const ourValues = [
        {
            letter: "A",
            title: "Accountability",
            image: "img-reliability",
            desc: "We take responsibility for every transaction, promise, and experience delivered to our customers and partners.",
        },
        {
            letter: "C",
            title: "Customer-centric",
            image: "img-fairness",
            desc: "Our users come first. Every improvement, feature, and decision is designed to serve our users' needs, simply and reliably.",
        },
        {
            letter: "C",
            title: "Collaboration",
            image: "img-team-work",
            desc: "We believe in teamwork—working closely with our users, partners, and team members to achieve shared success.",
        },
        {
            letter: "E",
            title: "Excellence",
            image: "img-opportunity",
            desc: "We strive for the highest standards in service delivery, technology, and customer experience.",
        },
        {
            letter: "S",
            title: "Security",
            image: "img-accessibility",
            desc: "We protect user data, funds, and transactions with strong security practices, building trust through transparency and reliability.",
        },
        {
            letter: "S",
            title: "Sustainable Growth",
            image: "img-growth",
            desc: "We are committed to continuous improvement and long-term growth for our users, team, and the communities we serve.",
        },
    ];

    const ourValues2 = [
        {
            letter: "A",
            title: "Accessibility",
            image: "img-accessibility",
            desc: "We make earning opportunities and essential services easy to access for everyone, regardless of income level.",
        },
        {
            letter: "F",
            title: "Fairness",
            image: "img-fairness",
            desc: "We ensure transparent earnings, honest rewards, and equitable access to affordable digital services.",
        },
        {
            letter: "F",
            title: "Flexibility",
            image: "img-flexibility",
            desc: "We allow users to earn, spend, and manage their bills at their convenience, anytime and anywhere.",
        },
        {
            letter: "O",
            title: "Opportunity",
            image: "img-opportunity",
            desc: "We create real earning opportunities that empower Nigerians to improve their financial stability.",
        },
        {
            letter: "R",
            title: "Reliability",
            image: "img-reliability",
            desc: "We provide dependable services—every payment, purchase, or earning is secure, trusted, and consistent.",
        },
        {
            letter: "D",
            title: "Dignity",
            image: "img-dignity",
            desc: "We support users with a platform that helps them earn with pride, meet daily needs, and take control of their financial lives.",
        },
    ];

    return (
        <div className="w-full">
                    <div className="flex flex-col items-center">
                        <div className="flex gap-x-2 border border-gray-200 dark:border-gray-700 rounded-md p-5">
                            {ourValues.map((item:any) => {
                                return (
                                    <button 
                                        key={item.title}
                                        type="button"
                                        className={`${selected.title === item.title? "active" : ""} size-10 lg:size-12 bg-slate-200 dark:bg-slate-800 text-gray-800 
                                           dark:text-gray-300 [&.active]:bg-blue-500 [&.active]:text-white rounded-md flex justify-center items-center text-xl lg:text-2xl font-bold 
                                            transition-all duration-500 cursor-pointer`
                                        }
                                        onClick={() => setSelected(item)}
                                    >
                                        { item.letter }
                                    </button>
                                );
                            })}
                        </div>
                        <div className="h-24 lg:h-40 w-px bg-gray-200 dark:bg-gray-700"></div>
                        <div className="flex gap-x-2 border border-gray-200 dark:border-gray-700 rounded-md p-5">
                            <AnimatePresence mode="wait">
                                {!_.isNil(selected) && (
                                    <motion.div
                                        key={selected ? selected.title : "company-value"}
                                        className="grid grid-cols-1 lg:grid-cols-2 ring-2 ring-slate-100 dark:ring-slate-800 rounded-md"
                                        initial={{ y: 10, opacity: 0 }}
                                        animate={{ y: 0, opacity: 1 }}
                                        exit={{ y: -10, opacity: 0 }}
                                        transition={{ duration: 0.2 }}
                                    >
                                        <div className={`h-20 w-80 lg:h-auto relative ${selected?.image} bg-cover bg-center`}>
                                            {/* <img src={selected?.image} alt={selected?.title} height="100%" width="100%" /> */}
                                            <div className="w-full h-full bg-gray-100/90 dark:bg-gray-800/95 flex justify-center items-center text-center">
                                                <h3 className="text-lg lg:text-2xl text-gray-800 dark:text-gray-300 font-extrabold tracking-wider">
                                                    { selected?.title }
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="h-auto lg:h-72 w-80 flex justify-center items-center px-7 py-5 lg:py-0">
                                            <p className="text-base lg:text-lg text-center text-gray-500 dark:text-gray-300">
                                                { selected?.desc }
                                            </p>
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    </div>
                </div>
    );
}